import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import {MenuItem} from 'primeng/api';

@Injectable({ providedIn: "root" })
export class MenuSuperiorService {
    items = new BehaviorSubject<MenuItem[]>([]);

    constructor() {}

    setItems(items: MenuItem[]) {
        this.items.next(items);
    }
}
